import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getResults = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.result.results.entries, filter);
};
